var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full video-background__wrapper"},[_c('div',{staticClass:"video-background"},[_c('div',{staticClass:"video-foreground"},[_c('youtube',{ref:"youtube",staticClass:"w-full video__wrapper",attrs:{"video-id":"2DJQqOMaRvk","player-vars":_vm.playerVars}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }